import { FunctionComponent } from "react";
import Bikelogorectangle from "./Bikelogorectangle";

const NewUsedFrame: FunctionComponent = () => {
  return (
    <section className="self-stretch bg-white overflow-y-auto flex flex-row items-end justify-center min-h-[1186px] max-w-full text-center text-45xl text-gray-100 font-racing-sans-one">
      <div className="h-[1067px] flex-1 flex flex-col items-start justify-start pt-0 px-0 pb-0 box-border max-w-full mq1350:h-auto">
        <div className="self-stretch overflow-y-auto flex flex-col items-center justify-start min-h-[4223px] max-w-full shrink-0">
          <div className="self-stretch flex flex-col items-start justify-start">
            <img
              className="self-stretch relative max-w-full overflow-hidden max-h-full"
              alt=""
              src="/bike-logo.svg"
            />
            <img
              className="self-stretch relative max-w-full overflow-hidden max-h-full object-cover z-[1] mt-[-615px]"
              loading="eager"
              alt=""
              src="/bikeshopphoto@2x.png"
            />
          </div>
          <div className="self-stretch bg-gray-500 flex flex-row items-center justify-between p-2.5 box-border min-h-[191px] gap-[10px] max-w-full">
            <div className="h-[81px] w-[1463px] relative flex items-center justify-center shrink-0 max-w-full mq800:text-32xl mq450:text-19xl">{`New & Used Bikes & Parts`}</div>
          </div>
          <div className="self-stretch flex flex-row items-start justify-center py-10 px-5 box-border [row-gap:20px] max-w-full text-black mq1125:pt-5 mq1125:pb-5 mq1125:box-border mq1350:flex-wrap mq1350:justify-center mq1350:pt-[26px] mq1350:pb-[26px] mq1350:box-border">
            <div className="w-[718px] flex flex-col items-start justify-start gap-[40px] min-w-[718px] max-w-full mq800:gap-[20px] mq800:min-w-full mq1350:flex-1">
              <div className="w-[689.3px] flex flex-col items-start justify-start py-0 px-5 box-border gap-[5px] max-w-full">
                <img
                  className="self-stretch h-[426px] relative max-w-full overflow-hidden shrink-0 object-cover"
                  loading="eager"
                  alt=""
                  src="/trek@2x.png"
                />
                <div className="self-stretch h-[81px] relative flex items-center justify-center mq800:text-32xl mq450:text-19xl">
                  Trek
                </div>
              </div>
              <div className="self-stretch flex flex-col items-start justify-start py-0 px-5 gap-[5px]">
                <img
                  className="self-stretch h-[426px] relative max-w-full overflow-hidden shrink-0 object-cover"
                  loading="eager"
                  alt=""
                  src="/santacruz@2x.png"
                />
                <div className="self-stretch h-[81px] relative flex items-center justify-center mq800:text-32xl mq450:text-19xl">
                  Santa Cruz
                </div>
              </div>
              <div className="w-[689.3px] flex flex-col items-start justify-start gap-[5px] max-w-full">
                <img
                  className="self-stretch h-[426px] relative max-w-full overflow-hidden shrink-0 object-cover"
                  loading="eager"
                  alt=""
                  src="/yeti@2x.png"
                />
                <div className="self-stretch h-[81px] relative flex items-center justify-center mq800:text-32xl mq450:text-19xl">
                  Yeti Cycle
                </div>
              </div>
            </div>
            <div className="w-[689.3px] flex flex-col items-start justify-start gap-[20px] min-w-[689.3px] max-w-full mq800:min-w-full mq1350:flex-1">
              <div className="self-stretch flex flex-col items-start justify-start py-0 px-5 gap-[5px]">
                <img
                  className="self-stretch h-[426px] relative max-w-full overflow-hidden shrink-0 object-cover"
                  loading="eager"
                  alt=""
                  src="/giant@2x.png"
                />
                <div className="self-stretch h-[81px] relative flex items-center justify-center mq800:text-32xl mq450:text-19xl">
                  Giant
                </div>
              </div>
              <div className="w-[637px] flex flex-col items-start justify-start py-0 px-5 box-border gap-[5px] max-w-full">
                <img
                  className="w-[650px] h-[472px] relative object-cover max-w-[109%] shrink-0"
                  loading="eager"
                  alt=""
                  src="/ytindustries@2x.png"
                />
                <div className="self-stretch h-[81px] relative flex items-center justify-center mq800:text-32xl mq450:text-19xl">
                  YT Industries
                </div>
              </div>
              <div className="self-stretch flex flex-col items-start justify-start gap-[5px]">
                <img
                  className="self-stretch h-[426px] relative max-w-full overflow-hidden shrink-0 object-cover"
                  loading="eager"
                  alt=""
                  src="/juliana@2x.png"
                />
                <div className="self-stretch h-[81px] relative flex items-center justify-center mq800:text-32xl mq450:text-19xl">
                  Juliana
                </div>
              </div>
            </div>
          </div>
          <Bikelogorectangle
            logo2="/logo2@2x.png"
            bikerider3="/bikerider3@2x.png"
          />
        </div>
      </div>
    </section>
  );
};

export default NewUsedFrame;
